import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=594772a0&scoped=true&lang=pug"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"
import style0 from "./footers.vue?vue&type=style&index=0&id=594772a0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594772a0",
  null
  
)

export default component.exports